export enum SplitFeatureFlag {
  NEW_TIER13_HOMEPAGE = 'CC-303-new-tier13-homepage',
  CONTENT_BLOCKS = 'spl13-collections-quickhits',
}

export const CONTROL_TREATMENT = 'control';

export enum MiniPDPRecommendStripTreatment {
  ON = 'spl17-search-ab-b-qvrecos',
  OFF = 'spl17-search-ab-a-control',
}

export enum DefaultTreatment {
  ON = 'on',
  OFF = 'off',
}

export enum ColorVariatsTreatment {
  ON = 'spl15-search-ab-b-pccolorways',
  OFF = 'spl15-search-ab-a-control',
}

export enum NewCollectionsPageSplitTreatment {
  DEFAULT = 'default',
  ON = 'on',
  OFF = 'off',
  CONTROL = CONTROL_TREATMENT,
}

export enum MiniPDPTreatment {
  OLD_VARIANT = 'spl09-search-ab-a-control',
  NEW_VARIANT_LARGE = 'spl09-search-ab-b-qvminipdplarge',
}
export enum A1BlockTreatment {
  CONTROL = CONTROL_TREATMENT,
  OFF = 'spl12-collections-ab-a-control',
  ON = 'spl12-collections-ab-b-recos',
}

export enum ContentBlocksTreatment {
  CONTROL = CONTROL_TREATMENT,
  OFF = 'spl13-collections-ab-a-control',
  ON = 'spl13-collections-ab-b-quickhits',
}
